import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { InsurancesService } from '../services/insurances/insurances.service';
import { DialogInsurances } from '../dialog/insurances/dialog.component.ins'; // Ajusta la ruta segons el teu projecte
import { ListService } from '../list.service';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';
import { IInsurance, IInsuranceResponse } from './insurances.interfaces';

@Component({
  selector: 'mcrit-gestio-insurances',
  templateUrl: './insurances.component.html',
  styleUrls: [ './insurances.component.css' ],
  providers: [ InsurancesService, ListService ]
})
export class InsurancesComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public insurancesData: IInsuranceResponse;
  public userInfo: any = {};
  
  private activeFilters: any = {};
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  private unsubscriber : Subject<void> = new Subject<void>();
  public showFilters: boolean = true;
  public export: boolean = false;
  public orderingParameters: any;

  private insuranceModel: IInsurance = {
    'plate': '',
    'name': '',
    'company': '',
    'policy_number': '',
    'policy_start_date': '',
    'policy_expiry_date': ''
  };
  
  public error: string = '';
  public showDialog: boolean = false;
  public editInsurancesData: IInsurance;

  constructor(
    public tokenStorage: TokenStorageService, public listInsurancesService: ListService, 
    public dialog: MatDialog, private insuranceService: InsurancesService, 
    private router: Router, private route: ActivatedRoute
  ) {
    this.userInfo = this.tokenStorage.getUser();
  }

  public exportar() { 
    this.export = true; 
    this.requestRowsToParent(); 
  }

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public addInsurance(): void {
    this.editInsurancesData = Object.assign({}, this.insuranceModel);
    let dialogFactRef = this.dialog.open(DialogInsurances, {
      disableClose: true, 
      height: '550px', 
      data: { dades: this.editInsurancesData, user: this.userInfo } 
    });
   
    dialogFactRef.afterClosed().subscribe(results => {
      if (!results) return;
      this.editInsurancesData = results;
      this.addOrUpdate();
    });
  }

  public editInsurance(insurance: IInsurance): void {
    this.editInsurancesData = Object.assign({}, this.insuranceModel, insurance);
    let dialogFactRef = this.dialog.open(DialogInsurances, {
      height: '550px', 
      data: { dades: this.editInsurancesData, user: this.userInfo } 
    });

    dialogFactRef.afterClosed().subscribe(results => {
      if (!results) return;
      this.editInsurancesData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    // Controlem si és nova a partir de si té número de pòlissa assignat
    if (!this.editInsurancesData.policy_number || this.editInsurancesData.policy_number === '') {
      this.insuranceService.create(this.editInsurancesData)
        .subscribe(res => {
          console.log("S'ha creat l'assegurança");
          this.router.navigate(['insurances']);
          this.requestRowsToParent();
        });
    } else {
      this.insuranceService.update(<string> this.editInsurancesData.policy_number, this.editInsurancesData)
        .subscribe(res => {
          console.log("S'hansen desat les dades");
          this.router.navigate(['insurances']);
          this.requestRowsToParent();
        });
    }
  }

  public gotoPage(page: number): void {
    this.listInsurancesService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event) {
    if (this.currentOrdering.length == 0) ['name'].map(item => this.currentOrdering[item] = this.orderingCycle[1]);
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listInsurancesService.currentPage * this.listInsurancesService.rowsPerPage;
    this.requestRowsToParent();
  }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key] ? this.orderingParameters[key] : 0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listInsurancesService.currentPage * this.listInsurancesService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listInsurancesService.rowsPerPage - 1, this.insurancesData.registers);
  }

  private requestRowsToParent(): void {
    this.insuranceService.getList(
      this.listInsurancesService.rowsPerPage, 
      this.listInsurancesService.currentPage * this.listInsurancesService.rowsPerPage, 
      this.activeFilters,
      {},
      this.currentOrdering, 
      this.export
    ).subscribe(
      data => {
        if (!this.export) {
          this.insurancesData = data;
          this.computeDisplayedRows();
        } else {
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff", csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export_insurances.csv");
          this.export = false;
        }
      },
      error => console.log(error)
    );
  }

  public requestPrevious(): void {
     this.listInsurancesService.currentPage = Math.max(0, this.listInsurancesService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listInsurancesService.currentPage = this.listInsurancesService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
     this.listInsurancesService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
  }

  public insurancesFilters: Array<any>;
  public ordreCamps: Array<any>;
  public tableFields: Array<any>;

  ngOnInit() {
    this.ordreCamps = ['plate'];

    // Camps visibles a la graella de les assegurances
    this.tableFields = [
      ['plate', 'Plate'],
      ['name', 'Owner Name'],
      ['company', 'Company'],
      ['policy_number', 'Policy Number'],
      ['policy_start_date', 'Start Date'],
      ['policy_expiry_date', 'Expiry Date']
    ];

    // Cerca dinàmica configurable pels camps de la teva taula insurances
    this.insurancesFilters = [
      { inputs: [] },
      {
        inputs: [
          {
            name: 'text',
            type: 'text',
            values: [
              {
                text: 'Plate',
                name: 'plate',
                autocomplete: 'plate',
                value: this.listInsurancesService.getSearchValues('text')
              },
              {
                text: 'Owner Name',
                name: 'name',
                autocomplete: 'name',
                value: this.listInsurancesService.getSearchValues('text')
              },
              {
                text: 'Company',
                name: 'company',
                autocomplete: 'company',
                value: this.listInsurancesService.getSearchValues('text')
              },
              {
                text: 'Policy Number',
                name: 'policy_number',
                autocomplete: 'policy_number',
                value: this.listInsurancesService.getSearchValues('text')
              }
            ]
          }
        ]
      }
    ];

    this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    
    ['policy_number'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
 
    const id = this.route.snapshot.paramMap.get('id');
    
    if (id) {
      this.computeActiveFilters({ plate: id });
    } else {
      this.computeActiveFilters({});
    }

    history.pushState(null, document.title, location.href);
    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  go(lloc, id) {
    this.router.navigate(['/'+lloc, id]); 
  }
}